import { Component, Input, Output, EventEmitter } from '@angular/core';
// TODO: https://git.sys.cigna.com/angular-guild/cigna-nx/issues/567
// TODO: resolve CHCP disables by bot
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FlaggedPatient } from '@cigna/chcp/shared/user-profile-data-access';

@Component({
  selector: 'cigna-patient-detail-item',
  templateUrl: './patient-detail-item.component.html',
  styleUrls: ['./patient-detail-item.component.scss', '../dashboard-tile.scss'],
})
export class PatientDetailItemComponent {
  @Input() isEditable = true;
  @Input() isRestrictedImpersonator = false;
  @Input() patient: FlaggedPatient;
  @Input() flaggedKeys: string[] = [];
  @Input() isFlagView = false;
  @Output() flag = new EventEmitter();

  flagClick(checked: boolean, patient: FlaggedPatient) {
    this.flag.emit({ checked, patients: [patient] });
  }

  parseCoverageType(type: string): string {
    return type === 'MHSR'
      ? 'mhsr'
      : ['DENT', 'DEN'].includes(type)
      ? 'den'
      : 'medbh';
  }

  formatQueryParams(date: string) {
    return {
      asof: !this.isFlagView
        ? date && date.length === 8
          ? `${date.substring(0, 4)}-${date.substring(4, 6)}-${date.substring(
              6,
              8,
            )}`
          : date
        : undefined,
    };
  }
}
